declare global {
  interface Window {
    Intercom?: (command: string, settings?: IntercomSettings) => void;
    intercomSettings?: IntercomSettings;
  }
}

export interface IntercomSettings {
  app_id?: string;
  /**
   * Suppresses Intercom's own floating launcher. Support is entered from the sidenav
   * Resources menu instead, so the default launcher would be a second, competing button.
   */
  hide_default_launcher?: boolean;
}

/**
 * Whether the Intercom Messenger snippet was rendered on this page.
 *
 * The template only emits the snippet when the app ID is configured AND the
 * intercom-messenger-chat flag is on, so its presence already encodes that decision --
 * there is nothing to re-evaluate client side. Every call below is guarded on this so
 * the helper is inert on a page that shipped Zendesk instead.
 */
export const isIntercomAvailable = (): boolean => Boolean(window?.Intercom);

/**
 * Starts the Messenger for an unidentified visitor (an Intercom Lead).
 *
 * No user_id and no JWT: identity verification is a separate piece of work. Leads
 * created now auto-merge into the User record once identity ships, so nothing is lost.
 */
export const boot = (settings: IntercomSettings = {}) => {
  if (!isIntercomAvailable()) return;

  window.Intercom('boot', {
    app_id: window.intercomSettings?.app_id,
    hide_default_launcher: true,
    ...settings,
  });
};

/** Opens the Messenger panel. Called from the Support entry points. */
export const show = () => {
  if (!isIntercomAvailable()) return;

  window.Intercom('show');
};

export default {
  isIntercomAvailable,
  boot,
  show,
};
